var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multipleTable"},[(_vm.listStatus )?_c('split-apply',{ref:"split",attrs:{"splitNum":_vm.splitNum,"tableData":_vm.data,"pageSize":_vm.pageSize,"total":_vm.total},on:{"current-events":_vm.getList,"save-current":_vm.savePage}}):_c('nodata',{attrs:{"message":'暂无相关账套',"h":"400"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }